<div class="bg-white">
    <div class="grid grid-cols-[4fr_auto_auto] p-3">
        <div class="flex-align-center flex">
            <rwidget-route-short-name
                [label]="scheduleRoute?.shortName"
                [color]="scheduleRoute?.icon?.color || scheduleRoute?.color"
                [shape]="scheduleRoute?.icon?.shape || ShapeType.ROUNDED"></rwidget-route-short-name>
            <div class="ml-3">
                <div>{{ schedulePatternTitle }}</div>
                <div class="bus-stop-distance text-xs text-ironside_grey">
                    {{ scheduleStop?.name }}
                    <span *ngIf="env.SEARCH_SETTINGS?.SHOW_DESCRIPTION ? scheduleStop?.desc : scheduleStop?.code"
                        >&#8226;</span
                    >
                    {{ env.SEARCH_SETTINGS?.SHOW_DESCRIPTION ? scheduleStop?.desc : scheduleStop?.code }}
                    <span *ngIf="scheduleRoute?.agency?.name && env.APP_NAME === 'peutk'">
                        &#8226; {{ scheduleRoute.agency?.name }}
                    </span>
                </div>
            </div>
        </div>

        <ion-button
            class="tartu-light:text-primary dark:filter-yellow"
            *ngIf="env.EXPLORE?.SHOW_FAVORITE_SCHEDULE"
            [attr.aria-label]="'SAVE_FAVORITE' | translate"
            (click)="handleClickFavoriteIcon()"
            slot="icon"
            fill="clear">
            <ion-icon
                *ngIf="!isFavoriteScheduleAlreadyExist()"
                src="{{ assetsPath$ | async }}/img/explore/notFavorite.svg"></ion-icon>
            <ion-icon
                *ngIf="isFavoriteScheduleAlreadyExist()"
                src="{{ assetsPath$ | async }}/img/explore/favorite.svg"></ion-icon>
        </ion-button>

        <ion-button [attr.aria-label]="'LOCAL_BTN_BACK' | translate" (click)="navigateBack()" slot="end" fill="clear">
            <ion-icon
                class="h-8 w-8 dark:filter-yellow"
                title="{{ 'LOCAL_BTN_BACK' | translate }}"
                attr.aria-label="{{ 'LOCAL_BTN_BACK' | translate }}"
                src="{{ assetsPath$ | async }}/img/explore/cross.svg"></ion-icon>
        </ion-button>
    </div>

    <div class="grid grid-cols-3 p-3 pb-0">
        <ridango-ui-tab-button
            [isSelected]="tabType === 'today'"
            [tabsCount]="3"
            [tabIndex]="1"
            [ariaLabel]="'LOCAL_CALENDAR_TODAY_dddd' | translate"
            (click)="changeTab(TabTypeEnum.TODAY)"
            >{{ 'LOCAL_CALENDAR_TODAY_dddd' | translate }}</ridango-ui-tab-button
        >
        <ridango-ui-tab-button
            [tabsCount]="3"
            [tabIndex]="2"
            [ariaLabel]="'TOMORROW' | translate"
            [isSelected]="tabType === 'tomorrow'"
            (click)="changeTab(TabTypeEnum.TOMORROW)"
            >{{ 'TOMORROW' | translate | uppercase }}</ridango-ui-tab-button
        >
        <ridango-ui-tab-button
            id="schedule-set-date"
            [tabsCount]="3"
            [tabIndex]="3"
            [isSelected]="tabType === 'date'"
            [ariaLabel]="'SET_DATE' | translate"
            (click)="changeTab(TabTypeEnum.DATE)">
            {{ setDateValue ? (setDateValue.datetime | date: getDateFormat()) : ('SET_DATE' | translate | uppercase) }}
        </ridango-ui-tab-button>
    </div>
</div>

<rwidget-schedule [highlightNextUpcomingStop]="isWatchingTodaySchedule()" [times]="times"></rwidget-schedule>

<div class="action-container flex flex-col" *ngIf="networkStatus$ | async">
    <button
        class="p-4 text-center text-primary dark:text-contrast-yellow"
        *ngFor="let action of actions"
        [attr.aria-label]="action.title | translate"
        (click)="handleAction(action)">
        {{ action.title | translate }}
    </button>
</div>
<ridango-ui-datetime-select
    [(ngModel)]="setDateValue"
    [triggerId]="'schedule-set-date'"
    (ngModelChange)="setStopTimes()"
    dateOnly="true"></ridango-ui-datetime-select>
